export default "/images/c6abb1e93c83d837b5aec9c487a0129c.avif";